import React from 'react';
import { motion } from 'framer-motion';
import { ParticleField } from '../shared/ParticleField';
import { ChevronDownIcon } from 'lucide-react';
import { HERO_BACKGROUND_IMAGE, HERO_BACKGROUND_IMAGE_MOBILE } from '../../data/signs';
export function Hero() {
  const scrollToGrid = () => {
    document.getElementById('sign-grid')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-cosmic-black py-20 md:py-24" data-id="element-214">
      {/* Background image — responsive mobile/desktop swap */}
      <div className="absolute inset-0 z-0" data-id="element-215">
        <picture data-id="element-216">
          <source media="(max-width: 767px)" srcSet={HERO_BACKGROUND_IMAGE_MOBILE} data-id="element-217" />
          <img src={HERO_BACKGROUND_IMAGE} alt="LOS 12 — Los Doce Reinos" className="w-full h-full object-cover" style={{
          opacity: 0.65
        }} loading="eager" decoding="async"
        // @ts-ignore - fetchpriority is valid HTML attribute
        fetchpriority="high" data-id="element-218" />
        </picture>

        {/* Lighter dark overlay for legibility (reduced from previous) */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(5,5,8,0.45) 0%, rgba(5,5,8,0.25) 50%, rgba(5,5,8,0.65) 100%)'
      }} data-id="element-219" />
        {/* Soft vignette */}
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(circle at center, transparent 0%, rgba(5,5,8,0.35) 85%, rgba(5,5,8,0.85) 100%)'
      }} data-id="element-220" />
      </div>

      {/* Particle layer — lighter density for mobile performance */}
      <ParticleField type="cosmic" density={25} data-id="element-221" />

      {/* Constellation overlay — desktop only to save mobile rendering cost */}
      <div className="hidden md:block absolute inset-0 opacity-10 z-[1] pointer-events-none" data-id="element-222">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-223">
          <defs data-id="element-224">
            <pattern id="constellation" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse" data-id="element-225">
              <circle cx="10" cy="10" r="1" fill="#C9A84C" data-id="element-226" />
              <circle cx="150" cy="50" r="1" fill="#C9A84C" data-id="element-227" />
              <circle cx="80" cy="120" r="1" fill="#C9A84C" data-id="element-228" />
              <circle cx="180" cy="180" r="1" fill="#C9A84C" data-id="element-229" />
              <line x1="10" y1="10" x2="150" y2="50" stroke="#C9A84C" strokeWidth="0.5" opacity="0.3" data-id="element-230" />
              <line x1="150" y1="50" x2="80" y2="120" stroke="#C9A84C" strokeWidth="0.5" opacity="0.3" data-id="element-231" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#constellation)" data-id="element-232" />
        </svg>
      </div>

      <div className="relative z-10 text-center px-5 md:px-6 max-w-4xl" data-id="element-233">
        {/* Emotional promise — premium eyebrow above the title */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 0.1
      }} className="inline-block max-w-2xl mx-auto mb-8 md:mb-10 px-5 py-3 md:px-6 md:py-4 rounded-xl backdrop-blur-md bg-[#00000000]" style={{
        background: 'rgba(8,6,14,0.32)',
        border: '1px solid rgba(232,212,139,0.16)',
        boxShadow: '0 4px 18px rgba(0,0,0,0.28)'
      }} data-id="element-234">
          <p className="text-sm md:text-base italic leading-relaxed font-medium font-['DM_Sans',_sans-serif] text-[#E8E7E7]" style={{
          textShadow: '0 2px 14px rgba(0,0,0,0.95)'
        }} data-id="element-235">
            No es astrología tradicional. Es una experiencia de identidad
            personal basada en patrones internos de Tu SIGNO Zodiacal
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.35
      }} data-id="element-236">
          <h1 className="text-6xl md:text-8xl lg:text-9xl font-serif font-bold mb-8 tracking-widest" style={{
          color: '#F5F5F0',
          textShadow: '0 0 40px rgba(201, 168, 76, 0.7), 0 4px 30px rgba(0,0,0,0.9)'
        }} data-id="element-237">
            LOS 12
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.7
      }} className="space-y-5 md:space-y-6" data-id="element-238">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-serif font-semibold text-white leading-snug max-w-3xl mx-auto px-2" style={{
          textShadow: '0 2px 30px rgba(0,0,0,0.95)'
        }} data-id="element-239">
            Descubre en Tu Reino que refleja tu forma de sentir, amar, pensar y
            vivir.
          </h2>
          <div className="inline-block max-w-2xl mx-auto px-5 py-3 md:px-6 md:py-4 rounded-xl backdrop-blur-md bg-[#08060E00]" style={{
          background: 'rgba(8,6,14,0.32)',
          border: '1px solid rgba(232,212,139,0.16)',
          boxShadow: '0 4px 18px rgba(0,0,0,0.28)'
        }} data-id="element-240">
            <p className="md:text-lg italic font-medium text-[16px] font-['DM_Sans',_sans-serif] text-[#F5F5F5]" style={{
            textShadow: '0 2px 14px rgba(0,0,0,0.95)'
          }} data-id="element-241">
              Portal privado con experiencias inmersivas y documentos
              exclusivos.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1.1
      }} className="mt-12 md:mt-14 flex flex-col items-center" data-id="element-242">
          <motion.button onClick={scrollToGrid} className="w-full sm:w-auto px-12 md:px-14 py-5 md:py-6 bg-gold-primary text-cosmic-black font-bold rounded-xl transition-all duration-300 tracking-[0.18em] text-base md:text-lg" style={{
          boxShadow: '0 0 50px rgba(201, 168, 76, 0.55), 0 0 90px rgba(201, 168, 76, 0.25), inset 0 0 0 1px rgba(245,240,225,0.4)'
        }} whileHover={{
          scale: 1.04,
          boxShadow: '0 0 80px rgba(201, 168, 76, 0.9), 0 0 120px rgba(201, 168, 76, 0.5)'
        }} whileTap={{
          scale: 0.96
        }} animate={{
          boxShadow: ['0 0 40px rgba(201, 168, 76, 0.5), 0 0 80px rgba(201, 168, 76, 0.2)', '0 0 65px rgba(201, 168, 76, 0.75), 0 0 110px rgba(201, 168, 76, 0.35)', '0 0 40px rgba(201, 168, 76, 0.5), 0 0 80px rgba(201, 168, 76, 0.2)']
        }} transition={{
          boxShadow: {
            duration: 3.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} data-id="element-243">
            DESCUBRIR MI REINO
          </motion.button>
          <div className="mt-6 inline-block max-w-lg mx-auto px-5 py-4 md:px-6 md:py-5 rounded-xl backdrop-blur-sm" style={{
          background: 'rgba(8,6,14,0.14)',
          border: '1px solid rgba(232,212,139,0.10)',
          boxShadow: '0 4px 14px rgba(0,0,0,0.18)'
        }} data-id="element-244">
            <p className="md:text-base font-serif italic tracking-wide font-medium text-center text-[20px] text-[#E7BF2E]" style={{
            textShadow: '0 2px 14px rgba(0,0,0,0.95)'
          }} data-id="element-245">
              Acceso inmediato
            </p>
            <ul className="mt-4 space-y-2 text-left" data-id="element-246">
              {[{
              emoji: '✔',
              text: 'Recibe tu acceso por correo'
            }, {
              emoji: '✨',
              text: 'Ingresa a tu Portal privado'
            }, {
              emoji: '🔓',
              text: 'Desbloquea tu Reino'
            }, {
              emoji: '📖',
              text: 'Comienza la experiencia desde cualquier dispositivo'
            }].map(item => <li key={item.text} className="flex gap-3 text-sm md:text-base text-gold-light/90 font-serif items-center justify-center" style={{
              textShadow: '0 2px 12px rgba(0,0,0,0.85)'
            }} data-id="element-247">
                  <span className="flex-shrink-0 leading-relaxed" data-id="element-248">
                    {item.emoji}
                  </span>
                  <span className="text-[13px] font-['Times_New_Roman',_serif] text-[#F5F3ED]" data-id="element-249">
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="mt-10 md:mt-14" data-id="element-250">
          <ChevronDownIcon size={32} className="mx-auto text-gold-primary opacity-60" data-id="element-251" />
        </motion.div>
      </div>
    </section>;
}